/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import * as ReactToPrint from 'react-to-print';
import {
  TimetableWrap,
  Title,
  // Details,
  // DetailItem,
  DetailItemkey,
  PrintButton,
} from '../../studentHome/styles';
import { PrimaryButton } from '../../../components';

import { InvRow, Details, DetailItem } from '../styles';
import { academicYear } from '../../../helpers';
import { toast } from 'react-toastify';
// import { GetInvigilatorPapersMutation } from '../../../generated/graphql';
import { useExamsTypeAndSem } from '../../../helpers/examTypeAndSemester';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * Timetable
 *
 * Displays the invigilator's exam timetable.
 * - Shows all allocations (sessions) for the invigilator.
 * - Allows printing of the timetable.
 *
 * Props:
 * - timetable: The invigilator's timetable data (should contain allocations array).
 */
export const Timetable = ({ timetable }: { timetable: any }): JSX.Element => {
  // Ref for the timetable section to be printed
  const timetableRef = React.useRef(null);
  // Get exam type and semester info
  const examTypeAndSemester = useExamsTypeAndSem();

  // Setup print handler using react-to-print
  const handlePrint = ReactToPrint.useReactToPrint({
    content: () => timetableRef.current,
    documentTitle: `my-${academicYear}-${examTypeAndSemester?.examType}
    -${examTypeAndSemester?.semester}
    -exams-timetable`,
    pageStyle: 'invigilator-print-timetable',
    onPrintError: () => toast.error('Printing of timetable failed!'),
  });

  return (
    <>
      {/* Timetable display section */}
      <TimetableWrap ref={timetableRef}>
        <Title>
          {/* Exam type, semester, and academic year */}
          {/* eslint-disable-next-line max-len */}
          Timetable for {examTypeAndSemester?.examType} {examTypeAndSemester?.semester} exams,{' '}
          {academicYear} academic year
        </Title>
        {/* Render each allocation/session, sorted by date */}
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {timetable?.getIngivilatorPapers?.allocations
          // Sort allocations by date
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ?.sort((a: any, b: any) => (new Date(a.date) as any) - (new Date(b.date) as any))
          // Render each allocation row
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ?.map((allocation: any) => (
            <InvRow key={allocation?._id}>
              {/* Left column: invigilator and session details */}
              <Details className="lg:w-1/2">
                <div>
                  <DetailItem>
                    <DetailItemkey>Name</DetailItemkey>{' '}
                    <span>: {timetable?.getIngivilatorPapers?.name}</span>
                  </DetailItem>
                  <DetailItem>
                    <DetailItemkey>Date</DetailItemkey> <span>: {allocation?.date}</span>
                  </DetailItem>
                  <DetailItem>
                    <DetailItemkey>Time</DetailItemkey> <span>: {allocation?.time}</span>
                  </DetailItem>
                  <DetailItem className="">
                    <DetailItemkey>Co - Invigilators :</DetailItemkey>{' '}
                    <div className="ml-6 flex flex-col">
                      <div>
                        {/* List all co-invigilators except the current user */}
                        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                        {allocation?.invigilators?.map((invigitor: any) => (
                          <div key={invigitor?._id}>
                            {invigitor?.name === timetable?.getIngivilatorPapers?.name
                              ? null
                              : invigitor?.name}
                          </div>
                        ))}
                      </div>
                    </div>
                  </DetailItem>
                </div>
              </Details>
              {/* Right column: room and location details */}
              <Details className="lg:w-1/2">
                <div>
                  <DetailItem>
                    <DetailItemkey>Room</DetailItemkey>
                    <span> : {allocation?.allocatedRoom?.name}</span>
                  </DetailItem>
                  <DetailItem>
                    <DetailItemkey>College</DetailItemkey>
                    <span> : {allocation?.allocatedRoom?.college}</span>
                  </DetailItem>
                  <DetailItem>
                    <DetailItemkey>Building</DetailItemkey>
                    <span> : {allocation?.allocatedRoom?.building}</span>
                  </DetailItem>
                  <DetailItem>
                    <DetailItemkey>Floor</DetailItemkey>
                    <span> : {allocation?.allocatedRoom?.floor}</span>
                  </DetailItem>
                </div>
              </Details>
            </InvRow>
          ))}
      </TimetableWrap>
      {/* Print button for timetable */}
      <PrintButton onClick={handlePrint}>
        <PrimaryButton name="Print" iconClass="fas fa-print" />
      </PrintButton>
    </>
  );
};
